// src/pages/Workers/Departments/FilterDrawer.jsx
import React, { useEffect,useRef, useState } from "react";
import { Box, Drawer, IconButton, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";
import { useSelector } from "react-redux";
 import WorkersMultiSelectDropdown from "../../../../components/workersMultiSelection";
import { BASE_URL } from "../../../../components/BaseUrl";

const statusOptions = [
  { key: "active", label: "Active", value: "active" },
  { key: "inactive", label: "Inactive", value: "inactive" },
];

const FilterDrawer = ({ open, onClose, filters, setFilters, onApplyFilters }) => {
  const { t } = useTranslation();
  // const [localFilters, setLocalFilters] = useState(filters);
  const [localFilters, setLocalFilters] = useState({
  ...filters,
  workers: filters?.workers || [],
});
const [workers, setWorkers] = useState([]);
const [loadingWorkers, setLoadingWorkers] = useState(false);

  const { company,  } = useSelector((state) => state.auth);
  const companyId = company?.id;
  const startRef = useRef(null);
  const endRef = useRef(null);

useEffect(() => {
  if (!open) return;

  const fetchPublicWorkers = async () => {
    try {
      setLoadingWorkers(true);

      const res = await fetch(
        `${BASE_URL}/public/workers?company_id=${companyId}`
      );

      const json = await res.json();

      if (!res.ok || json.error) {
        throw new Error(json.message || "Failed to fetch workers");
      }

      setWorkers(json.data.records || []);
    } catch (err) {
      console.error("Fetch public workers error:", err);
      setWorkers([]);
    } finally {
      setLoadingWorkers(false);
    }
  };

  fetchPublicWorkers();
}, [open]);

useEffect(() => {
  if (open) setLocalFilters(filters);
}, [open, filters]);


const workerOptions = workers.map((w) => ({
  value: w.id,
  label: `${w.first_name} ${w.last_name}`,
  email: w.email,
}));
  const apply = () => {
    onApplyFilters(localFilters); // parent will set + refetch with these
    onClose();
  };

const clear = () => {
  const cleared = {   workers: [], status: "", startDate: "", endDate: "" };
  setLocalFilters(cleared);
  onApplyFilters(cleared);
  onClose();
};

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: "100%", sm: 400, md: 550 }, backgroundColor: "#E7EBEE" },
      }}
    >
      {/* Header */}
      <Box sx={{ position: "sticky", top: 0, backgroundColor: "#E7EBEE", zIndex: 10, px: 2, py: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
      {t("filterDrawer.titleDepartments")}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >

   
<Box sx={{ mt: 3 }}>
  <label className="field_label">{t("filterDrawer.startDate")}</label>

    <input
      ref={startRef}
      onClick={() => startRef.current?.showPicker()} 
    type="date"
    value={localFilters.startDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4); // limit to 4 digits
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        setLocalFilters((prev) => ({
          ...prev,
          startDate: val,
        }));
      }
    }}
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
</Box>

{/* End Date */}
<Box sx={{ mt: 3 }}>
  <label className="field_label">{t("filterDrawer.endDate")}</label>
 
    <input
      ref={endRef}
      onClick={() => endRef.current?.showPicker()} 
    type="date"
    value={localFilters.endDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        setLocalFilters((prev) => ({
          ...prev,
          endDate: val,
        }));
      }
    }}
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
</Box>


          <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", gap: 2 }}>
            <CustomButton
              onClick={apply}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  {t("filterDrawer.apply")}
                </Box>
              }
              size="medium"
            />
            <Button
              variant="outlined"
              onClick={clear}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "fit-content",
              }}
            >
              {t("filterDrawer.clear")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
